import Highcharts from 'highcharts';
import { formatNumber } from '../../utils/helper';

export const metricsInPercentage = ['Share', 'CCI ND%', 'Comp ND%', '% Contri to NR India'];
export const metricsGrowthInPercentage = ['NR/UC'];

export const mapOptions = (
  topology: any,
  regionsData: any,
  onPointClick: (point: any) => void,
  selection: any,
): Highcharts.Options => {
  return {
    chart: {
      map: topology,
      width: 620,
      height: 670,

      spacing: [0, 0, 0, 0],
      alignTicks: false,
      animation: false,
      margin: [0, 0, 0, 0],
      style: {
        margin: '0 auto',
        paddingBottom: '50px',
      },
    },
    accessibility: {
      enabled: false,
      highContrastTheme: null,
    },
    title: {
      text: '',
    },
    mapView: {
      padding: 0,
      maxZoom: 100,
    },
    mapNavigation: {
      enabled: false,
      enableButtons: false,
    },
    credits: {
      enabled: false,
    },
    tooltip: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    series: [
      {
        type: 'map',
        name: 'India',
        data: regionsData.map((region: any) => ({
          ...region,
          color: region.colorValue === 5000 ? '#CCCCCC' : region.colorValue === 3000 ? '#E8E8E8' : region.color,
        })),
        mapData: topology,
        joinBy: ['name', 'name'],
        states: {
          hover: {
            color: '#CCCCCC',
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function () {
            const value = this.point.value ?? 0;
            const percentage = this.point.percentage ?? 0;
            const data = this.point?.data ?? 0;
            if (percentage === null || percentage === 0) return '';
            if (value > 100 && value < 200) {
              return '';
            }
            const formattedPercentage = metricsGrowthInPercentage.includes(selection[0])
              ? formatNumber(percentage, 2)
              : formatNumber(percentage * 100, 1) + '%';
            const formattedDataValue = metricsInPercentage.includes(selection[0])
              ? formatNumber(data * 100, 1)
              : formatNumber(data, 1);

            return `<span style="color: black; font-family:'Montserrat',sans-serif; font-size:13px; font-weight:700; line-height:12.48px;">${formattedDataValue}${
              selection[0] === '% Contri to NR India' ? '%' : ''
            }</span> <span style="color: grey; font-family:'Montserrat',sans-serif; font-size:13px; font-weight:700; line-height:12.48px;">(${formattedPercentage})</span>`;
          },
          style: {
            textOutline: '0px white',
            backgroundColor: 'transparent',
          },
        },
        borderColor: '#ffffff',
        borderWidth: 0.2,
        point: {
          events: {
            click: function (event) {
              onPointClick(event.point);
            },
          },
        },
      },
    ],
  };
};
